import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import waitFor from "@insite/client-framework/Common/Utilities/waitFor";
import {
    addToChainAfter,
    HandlerWithResult,
} from "@insite/client-framework/HandlerCreator";
import { BatchGetProductsApiParameter } from "@insite/client-framework/Services/ProductService";
import loadRealTimePricing from "@insite/client-framework/Store/CommonHandlers/LoadRealTimePricing";
import { chain, LoadRealTimeInventory } from "@insite/client-framework/Store/Components/OrderUpload/Handlers/BatchLoadProducts";
import {
    OrderUploadRowError,
} from "@insite/client-framework/Store/Components/OrderUpload/OrderUploadState";
import { ProductDto } from "@insite/client-framework/Types/ApiModels";

export interface BatchLoadProductsParameter extends BatchGetProductsApiParameter {
    firstRowHeading: boolean;
    checkInventory: boolean;
}
export interface BatchLoadProductsResult {
    apiParameter: BatchGetProductsApiParameter;
    apiResult: (ProductDto | null)[];
    products: ProductDto[];
    rowErrors: OrderUploadRowError[];
}
type HandlerType = HandlerWithResult<BatchLoadProductsParameter, BatchLoadProductsResult>;
export const LoadPricing: HandlerType = async ({ result: { apiResult }, dispatch, getState }) => {
    const products = apiResult.filter(p => !!p) as ProductDto[];
    const productInfoArr: ProductInfo[] = [];
    products.forEach(product => {
        const productInfo: ProductInfo = {
            productId: product.id,
            unitOfMeasure: product.unitOfMeasure,
            qtyOrdered: product.qtyOrdered,
            productDetailPath: product.productDetailUrl
        }
        productInfoArr.push(productInfo);
    });
    if (!productInfoArr.length) {
        return;
    }
    let loadedPricing = false;
    dispatch(
        loadRealTimePricing({
            productPriceParameters: productInfoArr,
            onComplete: realTimePricingProps => {
                if (realTimePricingProps.error) {
                    // TODO: Handle Error Here
                } else if (productInfoArr) {
                    realTimePricingProps.apiResult?.realTimePricingResults?.forEach(pricing => {
                        products
                            .filter(p => p.id === pricing.productId)
                            .forEach(product => {
                                product.pricing = pricing;
                            })
                    })
                }
                loadedPricing = true;
            },
        }));
    await waitFor(() => loadedPricing);
};
addToChainAfter(chain, LoadRealTimeInventory, LoadPricing);